var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIndependant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1578",
    d: "M15.5 0C10.8473 0 7.04526 3.8549 7.04526 8.57183C7.04526 13.2888 10.8473 17.142 15.5 17.142C20.1527 17.142 23.9547 13.2888 23.9547 8.57183C23.9547 3.8549 20.1527 0 15.5 0ZM15.5 2.85684C18.6296 2.85684 21.1358 5.39899 21.1358 8.57183C21.1358 11.7447 18.6296 14.2852 15.5 14.2852C12.3704 14.2852 9.86316 11.7447 9.86316 8.57183C9.86316 5.39899 12.3704 2.85684 15.5 2.85684ZM12.6811 20.0002C5.67964 20.0002 0 25.7593 0 32.8574V40H2.81789V32.8574C2.81789 27.9366 6.2433 23.912 10.8305 23.0435L8.49634 32.5104C8.43737 32.7496 8.44049 33.0001 8.50538 33.2377C8.57027 33.4754 8.69472 33.692 8.86664 33.8665L14.5035 39.5811C14.6343 39.7138 14.7897 39.8191 14.9607 39.8909C15.1317 39.9627 15.3149 39.9997 15.5 39.9997C15.6851 39.9997 15.8683 39.9627 16.0393 39.8909C16.2103 39.8191 16.3656 39.7138 16.4965 39.5811L22.1323 33.8665C22.3042 33.692 22.4287 33.4754 22.4936 33.2377C22.5584 33.0001 22.5616 32.7496 22.5026 32.5104L20.1684 23.0435C24.7557 23.912 28.1821 27.9366 28.1821 32.8574V40H31V32.8574C31 25.7593 25.3193 20.0002 18.3179 20.0002C18.1038 20.0002 17.8926 20.0496 17.7002 20.1448C17.5078 20.24 17.3393 20.3784 17.2076 20.5495C17.0758 20.7206 16.9842 20.9198 16.9398 21.1322C16.8954 21.3445 16.8992 21.5642 16.9511 21.7748L19.5755 32.4185L15.5 36.5503L11.4235 32.4185L14.0489 21.7748C14.1008 21.5641 14.1046 21.3442 14.0601 21.1318C14.0156 20.9194 13.924 20.7203 13.7921 20.5492C13.6602 20.3781 13.4916 20.2396 13.2991 20.1445C13.1066 20.0494 12.8952 20.0001 12.6811 20.0002Z",
    fill: "url(#paint0_linear_0_78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1578_2",
    d: "M15.5 0C10.8473 0 7.04526 3.8549 7.04526 8.57183C7.04526 13.2888 10.8473 17.142 15.5 17.142C20.1527 17.142 23.9547 13.2888 23.9547 8.57183C23.9547 3.8549 20.1527 0 15.5 0ZM15.5 2.85684C18.6296 2.85684 21.1358 5.39899 21.1358 8.57183C21.1358 11.7447 18.6296 14.2852 15.5 14.2852C12.3704 14.2852 9.86316 11.7447 9.86316 8.57183C9.86316 5.39899 12.3704 2.85684 15.5 2.85684Z",
    fill: "var(--fill-0, #119ED9)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_78",
    x1: -0.188345,
    y1: 1.74217,
    x2: 37.9235,
    y2: 11.7359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIndependant);
export default __webpack_public_path__ + "static/media/profile-independant.d7ffef6df9d171008d0383430f172624.svg";
export { ForwardRef as ReactComponent };